import { render, staticRenderFns } from "./v-navbar-logo.vue?vue&type=template&id=dffdc222&scoped=true&"
import script from "./v-navbar-logo.vue?vue&type=script&lang=js&"
export * from "./v-navbar-logo.vue?vue&type=script&lang=js&"
import style0 from "./v-navbar-logo.vue?vue&type=style&index=0&id=dffdc222&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffdc222",
  null
  
)

export default component.exports